export const API = {
  stats: {
    GET_ADMIN_CONFIG: () => '/api/v2/admin/config',
    EXPORT_QUOTATIONS: () => '/api/v2/admin/stats',
  },
};
